import React, {Component} from 'react';
import {withStyles} from '@material-ui/core/styles';
import { Dialog, Button, Typography, DialogContent } from '@material-ui/core';
// import Pagination from "material-ui-flat-pagination";

import { bindActionCreators } from 'redux';
import { withRouter } from 'react-router-dom';
import { connect } from 'react-redux';
import * as Actions from 'store/actions';

import CloseIcon from '@material-ui/icons/Close';

const styles = theme => ({
    layoutRoot: {},
    DialogPengguna: {
        width: '100%'
    },
});

class badgeAward extends Component {
    state = {
        error: null,
        open: false,
        badgeNama: '',
        badgeKeterangan: ''
    }

    componentDidMount = () => {
        // console.log(this.props.jenis_badge_id);

        this.setState({
            ...this.state,
            routeParams:{
                jenis_badge_id: this.props.jenis_badge_id,
                token: localStorage.getItem('jwt_token')
            }
        },()=>{
            // this.props.getJenisBadge(this.state.routeParams).then((result)=>{
            //     this.setState({
            //         ...this.state,
            //         badgeNama: this.props.jenis_badge.nama,
            //         badgeKeterangan: this.props.jenis_badge.keterangan
            //     })
            // });
        })
    }

    tutupDialog = () => {
        // this.setState({
        //     ...this.state,
        //     open: false
        // })
        console.log(this.props.toggle_badge);
        console.log(this.props.jenis_badge_id);
        let toggle_badge = {
            ...this.props.toggle_badge,
            [this.props.jenis_badge_id]: false
        };
        console.log(toggle_badge);

        this.props.toggleBadgeOpen(toggle_badge);
    }

    render()
    {
        const {classes} = this.props;
        
        return (
            // <div className="modalBadgeAward">
            //     <div className="badgeShowOff">
            //         &nbsp;
            //     </div>
            // </div>
            <Dialog
                open={this.props.toggle_badge[this.props.jenis_badge_id]}
                aria-labelledby="responsive-dialog-title"
                className={classes.DialogPengguna + " dialogBadgeAward"}
            >
                <Button variant="extendedFab" onClick={this.tutupDialog} style={{width:10, position: 'fixed', top: 50}}>
                    <CloseIcon/>
                </Button>
                {/* <DialogActions className="badgeShowOff">
                    &nbsp;
                </DialogActions> */}
                <DialogContent className="badgeShowOff">
                    {/* <br/>
                    <br/> */}
                    <div className="glowBadgeAward" style={{
                        background: 'url(http://'+window.location.host+'/assets/images/badges/'+this.props.jenis_badge_id+'.png)',
                        // background: 'url(http://pmp.dikdasmen.kemdikbud.go.id:1745/assets/images/badges/'+this.props.jenis_badge_id+'.png)',
                        backgroundSize: '100%',
                        backgroundRepeat: 'no-repeat',
                        backgroundPosition: 'center'
                    }}>
                        &nbsp;
                    </div>
                    <div style={{background: '#000', padding: 10, borderRadius: 10}}>
                        <Typography variant="display1" className="badgeAwardText">
                            Penghargaan
                            <br/>"{this.state.badgeNama}"
                        </Typography>
                        <Typography variant="subheading" className="badgeAwardText">
                            {this.state.badgeKeterangan}
                        </Typography>
                    </div>
                </DialogContent>
            </Dialog>
        )
    }
}

function mapDispatchToProps(dispatch) {
    return bindActionCreators({
        getPengguna: Actions.getPengguna,
        getJenisBadge: Actions.getJenisBadge,
        toggleBadgeOpen: Actions.toggleBadgeOpen
    }, dispatch);
}

function mapStateToProps({ Pengguna, App }) {

    return {
        pengguna: Pengguna.pengguna,
        jenis_badge: App.jenis_badge,
        toggle_badge: App.toggle_badge
    }
}

export default withStyles(styles, { withTheme: true })(withRouter(connect(mapStateToProps, mapDispatchToProps)(badgeAward)));



// WEBPACK FOOTER //
// ./src/main/badgeAward.js